import React, { useState, createContext } from "react";
import shallow from "zustand/shallow";
import useCurrentDealStore from "../../../stores/DealStore";
import { useFromUser } from "../../../stores/LocalStorageHelper";
import useCurrentLoginStore from "../../../stores/LoginStore";

export const FormsReportsContext = createContext();

const FormsReportsProvider = ({ children }) => {
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	const { dealerTempID } = useCurrentLoginStore((state) => state, shallow);
	const { buyerEmail } = useCurrentDealStore(
		(state) => ({
			buyerEmail: state.buyer.email,
		}),
		shallow
	);
	// Object with params for a single dcReport entry
	const [params, setParams] = useState({ dealerID, locationID });
	const [otherSignatures, setOtherSignatures] = useState({});
	const [pdfRequest, setPdfRequest] = useState({
		dealID: null,
		inventoryID: null,
		accountID: null,
		dcReportID: null,
		params,
		otherSignatures,
		dcReport: null,
		dealerTempID: dealerTempID,
	});

	const dealerEmail = JSON.parse(sessionStorage.getItem("user"))?.locations
		?.email;
	//	const dealerEmail = JSON.parse(sessionStorage.getItem("user"))?.email;
	// this can then contain a pdfRequest or a lenderPackRequest, add it at the end before making the final email request
	const [emailRequest, setEmailRequest] = useState({
		from: dealerEmail,
		to: buyerEmail || "",
		subject: "",
		body: "",
		fileName: null,
		cc: null,
		bcc: null,
	});

	const [listName, setListName] = useState("");

	const context = {
		setParams,
		setOtherSignatures,
		pdfRequest,
		setPdfRequest,
		emailRequest,
		setEmailRequest,
		listName,
		setListName,
	};
	return (
		<FormsReportsContext.Provider value={context}>
			{children}
		</FormsReportsContext.Provider>
	);
};

export default FormsReportsProvider;
